import * as React from 'react';
export default function SvgComponent() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4a.75.75 0 01.715.523L14.298 9.5h4.952a.75.75 0 01.46 1.342l-4.105 3.193 1.369 5.018a.75.75 0 01-1.2.776L12 16.722l-3.773 3.107a.75.75 0 01-1.2-.776l1.368-5.018-4.105-3.193A.75.75 0 014.75 9.5h4.952l1.583-4.977A.75.75 0 0112 4z"
  }));
}